import React from "react"; 
import '../src/custom.scss';
import MainLayoutContact from "./components/MainLayoutContact";
import SwiperSlider from "./components/SwiperSlider";
import OurProducts from "./components/OurProducts";
import OurServices from "./components/OurServices";
import WhyChooseUs from "./components/WhyChooseUs";
import CalltoAction from "./components/CalltoAction";
import ToolsSlider from "./components/ToolsSlider";
// import { FloatingWhatsApp } from "react-floating-whatsapp";
// import whatsappAvtar from "../src/assets/whatsappAvtar.jpg"





function App() {
  


  // const [ stylePath, setStylePath ] = useState('../src/custom.scss');


  // const handleButtonClick = () => {
  //   setStylePath({stylePath: '../src/custom2.scss'});
  //   alert(stylePath)
  // }


  // useEffect(() => {
  //   var head = document.head;
  //   var link = document.createElement("link");

  //   link.type = "text/css";
  //   link.rel = "stylesheet";
  //   link.href = stylePath;

  //   head.appendChild(link);

  //   return () => { head.removeChild(link); }

  // }, [stylePath]);



  return (
    <div className="App">

<>

{/* <button type="button" onClick={handleButtonClick}>
        Click to update stylesheet
      </button> */}

    <MainLayoutContact>
    <SwiperSlider/>
    <OurProducts/>
    <OurServices/>
    <WhyChooseUs/>
    <CalltoAction/>
    <ToolsSlider/>
    {/* <FloatingWhatsApp accountName="Monika" phoneNumber="917275591984" avatar={whatsappAvtar}/> */}
    </MainLayoutContact>

    </>
     


    </div>
  );
}

export default App;
